import React from 'react';
import {ShopContextProvider} from './src/context/Context';

export const wrapRootElement = ({element}) => {
	return <ShopContextProvider>{element}</ShopContextProvider>;
};
